import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SubForma } from '@app/shared';

@Component({
  selector: 'iw-visible-columns',
  templateUrl: './visible-columns.component.html',
  styleUrls: ['./visible-columns.component.scss']
})
export class VisibleColumnsComponent implements OnInit {
  // Formulario al cual se le mostrara la lista de controles
  @Input() form: SubForma;
  // Define si el componente activa la funcion de guardar
  @Input() actionSave = false;
  // Evento que retorna la forma con los cambios a guardar
  @Output() save: EventEmitter<SubForma> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.form.campos.forEach(control => {
      if (Array.isArray(control.propiedades)) {
        if (!control.propiedades || !control.propiedades.length) {
          control.propiedades = {
            mostrarTabla: false
          };
        }
      }
    });
  }

  /**
   * Emite el evento de guardar
   *
   * @memberof VisibleColumnsComponent
   */
  saveForm() {
    this.save.emit(this.form);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/visible-columns/visible-columns.component.ts